import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=33c1f57e&scoped=true"
import script from "./cookies.ts?vue&type=script&lang=ts&external"
export * from "./cookies.ts?vue&type=script&lang=ts&external"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=33c1f57e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1f57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c1f57e')) {
      api.createRecord('33c1f57e', component.options)
    } else {
      api.reload('33c1f57e', component.options)
    }
    module.hot.accept("./Cookies.vue?vue&type=template&id=33c1f57e&scoped=true", function () {
      api.rerender('33c1f57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/cookies/Cookies.vue"
export default component.exports